import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { collapseToast } from './collapseToast';
import { Default, SyntheticEvent } from './constants';
var AnimationStep;
(function (AnimationStep) {
    AnimationStep[AnimationStep["Enter"] = 0] = "Enter";
    AnimationStep[AnimationStep["Exit"] = 1] = "Exit";
})(AnimationStep || (AnimationStep = {}));
/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */
export function cssTransition(_a) {
    var enter = _a.enter, exit = _a.exit, _b = _a.appendPosition, appendPosition = _b === void 0 ? false : _b, _c = _a.collapse, collapse = _c === void 0 ? true : _c, _d = _a.collapseDuration, collapseDuration = _d === void 0 ? Default.COLLAPSE_DURATION : _d;
    return function ToastTransition(_a) {
        var children = _a.children, position = _a.position, preventExitTransition = _a.preventExitTransition, done = _a.done, nodeRef = _a.nodeRef, isIn = _a.isIn;
        var enterClassName = appendPosition ? "".concat(enter, "--").concat(position) : enter;
        var exitClassName = appendPosition ? "".concat(exit, "--").concat(position) : exit;
        var animationStep = useRef(AnimationStep.Enter);
        useLayoutEffect(function () {
            var node = nodeRef.current;
            var classToToken = enterClassName.split(' ');
            var onEntered = function (e) {
                var _a;
                if (e.target !== nodeRef.current)
                    return;
                node.dispatchEvent(new Event(SyntheticEvent.ENTRANCE_ANIMATION_END));
                node.removeEventListener('animationend', onEntered);
                node.removeEventListener('animationcancel', onEntered);
                if (animationStep.current === AnimationStep.Enter &&
                    e.type !== 'animationcancel') {
                    (_a = node.classList).remove.apply(_a, classToToken);
                }
            };
            var onEnter = function () {
                var _a;
                (_a = node.classList).add.apply(_a, classToToken);
                node.addEventListener('animationend', onEntered);
                node.addEventListener('animationcancel', onEntered);
            };
            onEnter();
        }, []);
        useEffect(function () {
            var node = nodeRef.current;
            var onExited = function () {
                node.removeEventListener('animationend', onExited);
                collapse ? collapseToast(node, done, collapseDuration) : done();
            };
            var onExit = function () {
                animationStep.current = AnimationStep.Exit;
                node.className += " ".concat(exitClassName);
                node.addEventListener('animationend', onExited);
            };
            if (!isIn)
                preventExitTransition ? onExited() : onExit();
        }, [isIn]);
        return children;
    };
}
export function SetCssBackgroundColorTransition(_a) {
    var _b = _a.bg, bgColor = _b === void 0 ? 'white' : _b, isIn = _a.isIn;
    var _c = useState(Default.IS_OUT_BG), bg = _c[0], setBg = _c[1];
    function debounce(currentColor, delay) {
        if (delay === void 0) { delay = Default.COLLAPSE_DURATION; }
        setTimeout(function () {
            setBg(currentColor);
        }, delay);
    }
    useEffect(function () {
        if (!isIn)
            debounce(Default.IS_OUT_BG, Default.COLLAPSE_DURATION / 2);
        else
            debounce(bgColor);
    }, [isIn]);
    return { backgroundColor: bg };
}
